<script>
export default {
    name: "PostedLPOs",

    data() {

        return {
            lpos: [],
            suppliers:[],
            filter:{
             search:"",
             supplierId:0,
             SearchOnly:false,
             dateFrom: window.moment().format(`YYYY-MM-DD`),
             dateTo: window.moment().format(`YYYY-MM-DD`),
                },

        };
    },
    computed: {

totalAmount() {
    if(!this.lpos.length) return 0;

    return this.lpos.map(inv => inv.grandTotal ? parseFloat(inv.grandTotal): 0)
        .reduce((amt,sum) => sum+amt);
},},

    mounted() {
        this.fetchAll();
        this.fetchSuppliers();
    },

    methods: {

        fetchAll() {
            this.$root.loading = true;
            this.$accountsHttp.get('SupplierLPO/PostedLPO').then(response => {
                this.lpos = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
        fetchSupplierLpos() {
            this.filter.SearchOnly=false;
           
            let url = `SupplierLPO/GetPostedSupplierLPO`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ? `&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
               return this.$http.get(url).then(({ data }) => {
                this.lpos = data;
            }).catch(() => {});
        },
          fetchSupplierLposSearchOnly() {
            this.filter.SearchOnly=true;
            let url = `SupplierLPO/GetPostedSupplierLPO`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ?`&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
                 return this.$http.get(url).then(({ data }) => {
                this.lpos = data;
            }).catch(() => {});
        },
          fetchSuppliers() {
            let url = `Shared/GetSuppliers`;

            return this.$http.get(url).then(({ data }) => {
                this.suppliers = data;
            }).catch(() => {});
        }
    },
}
</script>
<template>
    
   <div class="flex flex-wrap content-start overflow-auto" style="height:78vh;">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" 
                    @keydown.enter="fetchSupplierLposSearchOnly" 
                    placeholder="press enter to search only"
                    id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" 
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-cashier" class="label-control">Supplier:</label>
                  <v-select
                v-model="filter.supplierId" 
                :options="suppliers" 
                :reduce="supplier => supplier.id"
                label="name"
                class="bg-white text-sm" 
            />
              </div>
              
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="() => {
                        $root.loading=true;
                        fetchSupplierLpos().then(() => {
                            $root.loading=false;
                        }).catch(() => { $root.loading=false; });
                    }">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/6">Supplier</th>
                    <th class="p-tiny w-1/6">LPO No</th>
                    <th class="p-tiny w-1/6">Date</th>
                    <th class="p-tiny w-1/6">Delivery Date</th>
                    <th class="p-tiny w-1/6">Delivered</th>
                    <th class="p-tiny w-1/6">Cancelled</th>
                    <th class="p-tiny w-1/12">Amount</th>
                    <th class="p-tiny w-1/12">Action</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:60vh;">
                <tr class="w-full flex" v-for="(lpo, idx) in lpos" :key="idx">
                    <td class="p-tiny w-1/6">{{ lpo.supplier }}</td>
                    <td class="p-tiny w-1/6">{{ lpo.lpO_No }}</td>
                    <td class="p-tiny w-1/6">{{ lpo.date | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ lpo.deliveryDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ lpo.delivered }}</td>
                    <td class="p-tiny w-1/6">{{ lpo.asCancelled ? `Yes` : `No` }}</td>
                    <td class="p-tiny w-1/12">{{ lpo.grandTotal | numberFormat }}</td>
                    <td class="p-tiny w-1/12">
                        <router-link class="btn-sm btn-info text-xs rounded" 
                            :to="{ name: 'suppliers-dashboard.purchase-orders.view', params: { LPONo: lpo.lpO_No } }" title="View">
                                <i class="fa fa-eye"></i></router-link>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                    <tr class="w-full flex">
                          <th class="p-tiny flex-1"></th>
                          <th class="p-tiny flex-1"></th>
                          <th class="p-tiny flex-1"></th>
                          <th class="p-tiny flex-1"></th>
                          <th class="p-tiny flex-1"></th>
                          <th class="p-tiny flex-1"></th>
                             <th class="p-tiny flex-1" colspan="3">Total Amt: {{ totalAmount | numberFormat }}</th>
                          <th class="p-tiny flex-1"></th>
                      </tr>
                </tfoot>
        </table>
    </div>
</template>
